import styled from "styled-components";

const AdminFormSection = styled.section`
  padding: 1rem;
  border-radius: 16px;
  background: #202a43;
  border: 1px solid rgba(255, 255, 255, 0.08);
`;

export default AdminFormSection;
